<span class="proficiency" [ngbTooltip]="level.title" *ngFor="let level of levels; trackBy:trackers.trackByIndex;"
    [ngClass]="{'checked':skillLevel === level.value}">{{level.key}}</span>
